import { useCallback } from 'react'

export default function useIntersectionObserver(callback) {  // https://tkdodo.eu/blog/ref-callbacks-react-19-and-the-compiler
  return useCallback(node => {
    if (node !== null) (new IntersectionObserver(([entry]) => callback(entry))).observe(node);
  });
}
